// 日期控件
// 附有 “上一日”，“下一日”，“查询”，“导出” 等功能
<template>
  <el-row :gutter="gutter">
    <el-col :span="8">
      <el-date-picker v-model="value" align="right" type="date" placeholder="选择日期"
                      :picker-options="pickerOptions"></el-date-picker>
    </el-col>
    <el-col :span="12">
      <el-button @click="prevDay()">上一日</el-button>
      <el-button :disabled="nextDayAvailable" @click="nextDay()">下一日</el-button>
      <el-button @click="search()">查询</el-button>
    </el-col>
    <el-col :span="4" style="text-align: right">
      <slot></slot>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "DatePickerWithExport",
  data() {
    return {
      gutter: 10,
      format: 'YYYY-MM-DD',

      value: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    }
  },
  created() {
    this.initDateValue();
  },
  methods: {
    /**
     * 获取 上一天/下一天
     * next=true，为下一天
     * next=false，为上一天
     * */
    getAnotherDay(value, next) {
      let result;
      let moment = this.$moment(value);
      if (next) {
        result = moment.add("1", "d");
      } else {
        result = moment.subtract("1", "d");
      }

      return result.format(this.format);
    },
    /**
     * 获取上一天
     * */
    getPrevDay(value) {
      return this.getAnotherDay(value, false);
    },
    /**
     * 获取下一天
     * */
    getNextDay(value) {
      return this.getAnotherDay(value, true);
    },
    /**
     * 上一天
     * */
    prevDay() {
      this.value = this.getPrevDay(this.value);
      this.$emit('prevDayClick',this.value);
    },
    /**
     * 下一天
     * */
    nextDay() {
      this.value = this.getNextDay(this.value);
      this.$emit('nextDayClick',this.value);
    },
    /**
     * 初始化日期为当前时间
     * */
    initDateValue() {
      this.value = this.$moment().format(this.format);
    },

    search(){
      this.$emit('searchClick',this.value);
    }
  },
  computed: {
    /**
     * 动态控制 "下一日" 按钮是否可用
     * 1.等于当前日期时禁用
     * */
    nextDayAvailable() {
      return this.$moment().format(this.format) === this.value;
    },

    /**
     * 返回 this.info.attributeKeyNameMaps 中 show=true 的数组
     * */
    attributeKeyNameMapsComputed() {
      return this.info.attributeKeyNameMaps.filter(val => {
        return val.show
      });
    }
  },


}
</script>

<style scoped>

</style>
